<template>
  <div>
    <SignUpLayoutBox>
      <SignUpBackButton class="lg:flex hidden" @back-button-click="$router.push($i18n.localePath({ name: previousRoute || 'men-signup', params: previousRouteParams }))" />
      <div class="lg:px-10 lg:pb-12 text-gray-600">
        <h1 class="ota-title lg:ota-headline mt-7 text-center lg:text-left lg:ml-14 lg:mt-10" v-text="$t('SignUp.StepOne.SizeTable')" />
        <div class="mt-12 mx-6 lg:mx-15">
          <SizeChart />
        </div>
        <div class="text-center">
          <OButton
            variant="secondary"
            class="mt-7 mb-7 lg:hidden"
            @click="$router.push($i18n.localePath({ name: 'men-signup' }))"
          >
            {{ $t('SignUp.StepOne.BackButton') }}
          </OButton>
        </div>
      </div>
    </SignUpLayoutBox>

    <div class="pb-6 pt-20 mb-24 md:mb-14">
      <PolicyLinks />
    </div>
  </div>
</template>

<script>
import signupMixin from '@/mixins/signup'
const SignUpLayoutBox = () => import('@/components/SignUpLayoutBox')
const SignUpBackButton = () => import('@/components/SignUpBackButton')
const OButton = () => import('@/components/OButton')
const SizeChart = () => import('@/components/SizeChart/SizeChart')

export default {
  name: 'LoginSizeChart',
  layout: 'signup-men',
  components: {
    SizeChart,
    SignUpLayoutBox,
    OButton,
    SignUpBackButton
  },
  mixins: [signupMixin({ currentStep: 1, previousRoute: 'men-signup' })]
}
</script>

<style lang="postcss" scoped>
.signup-back-button {
  top: 3.5rem;
  left: 4rem;
}

@screen lg {
  .signup-back-button {
    top: 5rem;
  }
}
</style>
